import { Button, Container, Paper, Typography } from "@mui/material";
import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";
import { useEffect } from "react";

const Login = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  // useEffect(()=> {
  //   if(document.referrer){
  //     instance.loginRedirect(loginRequest);
  //   }
  // },[])

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={5}
        sx={{
          display: "flex",
          flexDirection: "column",
          p: 4,
          borderRadius: "10px",
        }}
      >
        <Typography
          align="center"
          variant="h5"
          sx={{ mb: 1, letterSpacing: "1px" }}
          fontWeight={700}
        >
          Playground
        </Typography>
        <Typography variant="subtitle2" fontSize="12px" align="center">
          Welcome to the Playground Chat!
        </Typography>
        <Button
          color="primary"
          variant="contained"
          sx={{ mt: 3 }}
          onClick={() => handleLogin()}
        >
          Company Single Sign-On
        </Button>
      </Paper>
    </Container>
  );
};

export default Login;
